import { render, staticRenderFns } from "./ProfessionalRegistrationFields.vue?vue&type=template&id=a35797a4"
import script from "./ProfessionalRegistrationFields.vue?vue&type=script&lang=js"
export * from "./ProfessionalRegistrationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports